import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import _ from 'lodash';

const styles = theme => ({
  listKey: {
    color: theme.palette.lightGrey,
    width: '120px',
    fontSize: '14px'
  }
});

class PersonalDetails extends React.Component {
  address = () => {
    const { person } = this.props;
    const street = _.get(this.props.application, '.residentialAddress.streetAddress');
    const city = _.get(this.props.application, 'residentialAddress.city');
    const postcode = _.get(this.props.application, 'residentialAddress.postcode');
    const state = _.get(this.props.application, 'residentialAddress.state');
    return [street, city, postcode, state].join(' ');
  }

  render = () => {
    const { person } = this.props;
    return (
      <div>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Name" />
            <ListItemText primary={person.fullName} />
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Mobile" />
            <ListItemText primary={person.mobile} />
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Mobile" />
            <ListItemText primary={person.email} />
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Title" />
            <ListItemText primary={person.title} />
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="No. of Dependents" />
            <ListItemText primary={person.dependents} />
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="DOB" />
            <ListItemText primary={person.dateOfBirth} />
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Martial Status" />
            <ListItemText primary={person.maritalStatus} />
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Residential Status" />
            <ListItemText primary={person.residentialStatus} />
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Residential Status" />
            <ListItemText primary={this.address()} />
          </ListItem>
        </List>
      </div>
    );
  }
}

const styled = withStyles(styles)(PersonalDetails)
export default styled;



// WEBPACK FOOTER //
// ./src/components/Applications/PersonalDetails.js